module.exports = __webpack_public_path__ + "img/circle-ring.17dfb128.svg";